// extracted by mini-css-extract-plugin
export default {"react-tooltip":"Tooltip_react-tooltip__MlZvC","medfar-tooltip":"Tooltip_medfar-tooltip__sggBx"};